import type { MouseEventHandler, PointerEventHandler } from "react";

type InstantPressHandlers<T extends HTMLElement> = {
  onClick: MouseEventHandler<T>;
  onPointerDown: PointerEventHandler<T>;
};

export function createInstantPressHandlers<T extends HTMLElement>(
  onPress: () => void
): InstantPressHandlers<T> {
  return {
    onPointerDown: (event) => {
      if (event.button !== 0) {
        return;
      }

      event.preventDefault();
      onPress();
    },
    onClick: (event) => {
      if (event.detail !== 0) {
        return;
      }

      onPress();
    }
  };
}
